export default __webpack_public_path__ + "static/media/zipIcon.10c90939.svg";